import { tabs_children, bs_tabs_children, app_tabs_children } from "./menus/index"
import { getOptDes } from "./menus/optDes"
const cxTabs = {
  name: "cxTabs",
  desc: "tabs样式",
  render: () => import("./render/index.vue"),
  optDes: getOptDes,
  enable: true,
  menus: {
    app: [
      {
        name: "标签页",
        children: app_tabs_children,
        group: "element",
        enable: true,
        sort: 140
      }
    ],
    bigScreen: [
      {
        name: "标签页",
        children: bs_tabs_children,
        group: "element",
        sort: 110,
        enable: params => params.admin
      }
    ],
    portal: [
      {
        name: "标签页",
        children: tabs_children,
        group: "element",
        enable: true,
        sort: 140
      }
    ]
  },
  toolbars: [
    {
      name: "cxTabs",
      label: "选项卡",
      comp: {
        tabsComponentData: () => import("./toolbars/tabs-options-data.vue"),
        tabsComponentSetting: () => import("./toolbars/tabs-options-setting.vue"),
        tabsComponentStyle: () => import("./toolbars/tabs-options-style.vue"),
        tabsComponentConfig: () => import("./toolbars/tabs-options-config.vue"),
      }
    }
  ]
}

export default cxTabs
